[{"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},
{"id":784,"alpha2":"ae","alpha3":"are","name":"Förenade Arabemiraten"},
{"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},
{"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua och Barbuda"},
{"id":8,"alpha2":"al","alpha3":"alb","name":"Albanien"},
{"id":51,"alpha2":"am","alpha3":"arm","name":"Armenien"},
{"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},
{"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},
{"id":40,"alpha2":"at","alpha3":"aut","name":"Österrike"},
{"id":36,"alpha2":"au","alpha3":"aus","name":"Australien"},
{"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbajdzjan"},
{"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnien och Hercegovina"},
{"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},
{"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},
{"id":56,"alpha2":"be","alpha3":"bel","name":"Belgien"},
{"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},
{"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgarien"},
{"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrain"},
{"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},
{"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},
{"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},
{"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia"},
{"id":76,"alpha2":"br","alpha3":"bra","name":"Brasilien"},
{"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},
{"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},
{"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},
{"id":112,"alpha2":"by","alpha3":"blr","name":"Belarus"},
{"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},
{"id":124,"alpha2":"ca","alpha3":"can","name":"Kanada"},
{"id":180,"alpha2":"cd","alpha3":"cod","name":"Kongo-Kinshasa"},
{"id":140,"alpha2":"cf","alpha3":"caf","name":"Centralafrikanska republiken"},
{"id":178,"alpha2":"cg","alpha3":"cog","name":"Kongo-Brazzaville"},
{"id":756,"alpha2":"ch","alpha3":"che","name":"Schweiz"},
{"id":384,"alpha2":"ci","alpha3":"civ","name":"Elfenbenskusten"},
{"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},
{"id":120,"alpha2":"cm","alpha3":"cmr","name":"Kamerun"},
{"id":156,"alpha2":"cn","alpha3":"chn","name":"Kina"},
{"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},
{"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},
{"id":192,"alpha2":"cu","alpha3":"cub","name":"Kuba"},
{"id":132,"alpha2":"cv","alpha3":"cpv","name":"Kap Verde"},
{"id":196,"alpha2":"cy","alpha3":"cyp","name":"Cypern"},
{"id":203,"alpha2":"cz","alpha3":"cze","name":"Tjeckien"},
{"id":276,"alpha2":"de","alpha3":"deu","name":"Tyskland"},
{"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},
{"id":208,"alpha2":"dk","alpha3":"dnk","name":"Danmark"},
{"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},
{"id":214,"alpha2":"do","alpha3":"dom","name":"Dominikanska republiken"},
{"id":12,"alpha2":"dz","alpha3":"dza","name":"Algeriet"},
{"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},
{"id":233,"alpha2":"ee","alpha3":"est","name":"Estland"},
{"id":818,"alpha2":"eg","alpha3":"egy","name":"Egypten"},
{"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},
{"id":724,"alpha2":"es","alpha3":"esp","name":"Spanien"},
{"id":231,"alpha2":"et","alpha3":"eth","name":"Etiopien"},
{"id":246,"alpha2":"fi","alpha3":"fin","name":"Finland"},
{"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiji"},
{"id":583,"alpha2":"fm","alpha3":"fsm","name":"Mikronesiska federationen"},
{"id":250,"alpha2":"fr","alpha3":"fra","name":"Frankrike"},
{"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},
{"id":826,"alpha2":"gb","alpha3":"gbr","name":"Storbritannien"},
{"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},
{"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgien"},
{"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},
{"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},
{"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},
{"id":226,"alpha2":"gq","alpha3":"gnq","name":"Ekvatorialguinea"},
{"id":300,"alpha2":"gr","alpha3":"grc","name":"Grekland"},
{"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},
{"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bissau"},
{"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},
{"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},
{"id":191,"alpha2":"hr","alpha3":"hrv","name":"Kroatien"},
{"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},
{"id":348,"alpha2":"hu","alpha3":"hun","name":"Ungern"},
{"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesien"},
{"id":372,"alpha2":"ie","alpha3":"irl","name":"Irland"},
{"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},
{"id":356,"alpha2":"in","alpha3":"ind","name":"Indien"},
{"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},
{"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},
{"id":352,"alpha2":"is","alpha3":"isl","name":"Island"},
{"id":380,"alpha2":"it","alpha3":"ita","name":"Italien"},
{"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},
{"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordanien"},
{"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japan"},
{"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenya"},
{"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirgizistan"},
{"id":116,"alpha2":"kh","alpha3":"khm","name":"Kambodja"},
{"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},
{"id":174,"alpha2":"km","alpha3":"com","name":"Komorerna"},
{"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint Kitts och Nevis"},
{"id":408,"alpha2":"kp","alpha3":"prk","name":"Nordkorea"},
{"id":410,"alpha2":"kr","alpha3":"kor","name":"Sydkorea"},
{"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},
{"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazakstan"},
{"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},
{"id":422,"alpha2":"lb","alpha3":"lbn","name":"Libanon"},
{"id":662,"alpha2":"lc","alpha3":"lca","name":"Saint Lucia"},
{"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},
{"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},
{"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},
{"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},
{"id":440,"alpha2":"lt","alpha3":"ltu","name":"Litauen"},
{"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburg"},
{"id":428,"alpha2":"lv","alpha3":"lva","name":"Lettland"},
{"id":434,"alpha2":"ly","alpha3":"lby","name":"Libyen"},
{"id":504,"alpha2":"ma","alpha3":"mar","name":"Marocko"},
{"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},
{"id":498,"alpha2":"md","alpha3":"mda","name":"Moldavien"},
{"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},
{"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagaskar"},
{"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshallöarna"},
{"id":807,"alpha2":"mk","alpha3":"mkd","name":"Nordmakedonien"},
{"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},
{"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},
{"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongoliet"},
{"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauretanien"},
{"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},
{"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},
{"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldiverna"},
{"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},
{"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexiko"},
{"id":458,"alpha2":"my","alpha3":"mys","name":"Malaysia"},
{"id":508,"alpha2":"mz","alpha3":"moz","name":"Moçambique"},
{"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},
{"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},
{"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},
{"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},
{"id":528,"alpha2":"nl","alpha3":"nld","name":"Nederländerna"},
{"id":578,"alpha2":"no","alpha3":"nor","name":"Norge"},
{"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},
{"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},
{"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nya Zeeland"},
{"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},
{"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},
{"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},
{"id":598,"alpha2":"pg","alpha3":"png","name":"Papua Nya Guinea"},
{"id":608,"alpha2":"ph","alpha3":"phl","name":"Filippinerna"},
{"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},
{"id":616,"alpha2":"pl","alpha3":"pol","name":"Polen"},
{"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},
{"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},
{"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},
{"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},
{"id":642,"alpha2":"ro","alpha3":"rou","name":"Rumänien"},
{"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbien"},
{"id":643,"alpha2":"ru","alpha3":"rus","name":"Ryssland"},
{"id":646,"alpha2":"rw","alpha3":"rwa","name":"Rwanda"},
{"id":682,"alpha2":"sa","alpha3":"sau","name":"Saudiarabien"},
{"id":90,"alpha2":"sb","alpha3":"slb","name":"Salomonöarna"},
{"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychellerna"},
{"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudan"},
{"id":752,"alpha2":"se","alpha3":"swe","name":"Sverige"},
{"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapore"},
{"id":705,"alpha2":"si","alpha3":"svn","name":"Slovenien"},
{"id":703,"alpha2":"sk","alpha3":"svk","name":"Slovakien"},
{"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},
{"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},
{"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},
{"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},
{"id":740,"alpha2":"sr","alpha3":"sur","name":"Surinam"},
{"id":728,"alpha2":"ss","alpha3":"ssd","name":"Sydsudan"},
{"id":678,"alpha2":"st","alpha3":"stp","name":"São Tomé och Príncipe"},
{"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},
{"id":760,"alpha2":"sy","alpha3":"syr","name":"Syrien"},
{"id":748,"alpha2":"sz","alpha3":"swz","name":"Swaziland"},
{"id":148,"alpha2":"td","alpha3":"tcd","name":"Tchad"},
{"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},
{"id":764,"alpha2":"th","alpha3":"tha","name":"Thailand"},
{"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadzjikistan"},
{"id":626,"alpha2":"tl","alpha3":"tls","name":"Östtimor"},
{"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},
{"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunisien"},
{"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},
{"id":792,"alpha2":"tr","alpha3":"tur","name":"Turkiet"},
{"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad och Tobago"},
{"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},
{"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania"},
{"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraina"},
{"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},
{"id":840,"alpha2":"us","alpha3":"usa","name":"USA"},
{"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},
{"id":860,"alpha2":"uz","alpha3":"uzb","name":"Uzbekistan"},
{"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint Vincent och Grenadinerna"},
{"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},
{"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},
{"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},
{"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},
{"id":887,"alpha2":"ye","alpha3":"yem","name":"Jemen"},
{"id":710,"alpha2":"za","alpha3":"zaf","name":"Sydafrika"},
{"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},
{"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"}]